import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { documentSuggestionsApi } from 'src/Services/API';
import { DocumentAnalysisStatus, DocumentSuggestionDto } from 'src/Services/API/generated';

const ANALYSIS_POLL_INTERVAL_MS = 4000;

/**
 * Current user's uploads being analyzed (OCR) or awaiting a rename/filing decision.
 * Polls while an analysis is running.
 */
const useFetchDocumentSuggestions = () => {
  const assetId = useCurrentAssetId();

  return useQuery<DocumentSuggestionDto[]>({
    queryKey: ['document-suggestions', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await documentSuggestionsApi.documentClassificationControllerFindAll(assetId)).data;
    },
    enabled: !!assetId,
    refetchInterval: data =>
      data?.some(suggestion => suggestion.status === DocumentAnalysisStatus.Analyzing)
        ? ANALYSIS_POLL_INTERVAL_MS
        : false,
    refetchIntervalInBackground: false,
  });
};

export default useFetchDocumentSuggestions;
